/* ==========================================================================
   Olfatto v2 — selector de volumen

   Todos los productos del catálogo tienen una sola opción ("Tamaño"), así
   que basta con mapear cada radio a su variante. Sin dependencias y sin
   tocar los custom elements de Dawn.

   Si el JS falla, el formulario sigue enviando la variante preseleccionada:
   se puede comprar igual, solo que sin poder cambiar de tamaño.
   ========================================================================== */
(function () {
  'use strict';

  function init(form) {
    var hidden = form.querySelector('[data-olf-variant-id]');
    var price = form.querySelector('[data-olf-price]');
    var btn = form.querySelector('[data-olf-add]');
    var label = form.querySelector('[data-olf-add-label]');
    var radios = form.querySelectorAll('input[name="olf-opt"]');
    if (!hidden || !radios.length) return;

    function sync(r) {
      if (!r || !r.value) return;
      hidden.value = r.value;
      if (price && r.dataset.price) price.textContent = r.dataset.price;

      var ok = r.dataset.available === 'true';
      if (btn) btn.disabled = !ok;
      if (label) label.textContent = ok ? 'Agregar a la bolsa' : 'Agotado';
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        sync(r);
      });
    });

    var checked = form.querySelector('input[name="olf-opt"]:checked');
    if (checked) sync(checked);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.olf-pdp__form').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
